// extracted by mini-css-extract-plugin
export var container = "_60-1";
export var editor = "_60-2";
export var resizable = "_60-3";
export var wrapper = "_60-0";